import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import NotFound from "../pages/general/NotFound";
import Dashboard from "../pages/client/dashboard/Dashboard";
import PrivateLayout from "../components/layout/PrivateLayout";
import Login from "../pages/auth/Login";
import PublicLayout from "../components/layout/PublicLayout";
import RegisterMain from "../pages/auth/register/RegisterMain";
import ClinicSettings from "../pages/client/settings/clinic/ClinicSettings";
import ActiveModules from "../pages/client/settings/modules/ActiveModules";
import PaymentsInvoices from "../pages/client/settings/payments/PaymentsInvoices";
import PatientListNew from "../pages/client/patientsNew/list/PatientListNew";
import PatientSingleNew from "../pages/client/patientsNew/single/PatientSingleNew";
import EmployeeList from "../pages/client/employees/list/EmployeeList";
import TreatmentPlanListNew from "../pages/client/treatmentplans/list/TreatmentPlanListNew-old";
import ServiceListNew from "../pages/client/services/list/ServiceListNew";
import ServiceGroupListNew from "../pages/client/serviceGroups/list/ServiceGroupListNew";
import ProfessionListNew from "../pages/client/professions/list/ProfessionListNew";
import ProfessionGroupListNew from "../pages/client/professionGroups/list/ProfessionGroupListNew";
import PatientPortalPage from "../pages/client/patientsNew/portal/PatientPortalPage";
import OnboardingPage from "../pages/client/onboarding/OnboardingPage";
import TenantSelectPage from "../pages/general/TenantSelectPage";
import ClinicUsers from "../pages/client/settings/users/ClinicUsers";
import InvitePage from "../pages/general/InvitePage";
import ResetPasswordPage from "../pages/auth/partials/ResetPasswordPage";
import UserProfilePage from "../pages/client/users/single/UserProfilePage";
import LogoutPage from "../pages/general/LogoutPage";
import VerifyEmailPage from "../pages/auth/register/VerifyEmailPage";
import TestingPage from "../pages/client/testing/TestingPage";
import CalendarMain from "../pages/client/appointmentsNew/CalendarMain";
import EmployeeSingle from "../pages/client/employees/single/EmployeeSingle";

const ProtectedRoute = ({ element }) => {
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;
  return userInfo ? element : <Navigate to="/login" replace />;
};

const AppRoutes = () => {
  return (
    <>
      {/* <HeaderMain /> */}

      <Routes>
        {/* ✅ PUBLIC ROUTES - Accessible by Everyone */}
        <Route element={<PublicLayout />}>
          <Route path="/testing" element={<TestingPage />} />

          <Route path="/" element={<Login />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterMain />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route
            path=":slug/portal/patient/:patientId"
            element={<PatientPortalPage />}
          />
        </Route>
        <Route
          path="/select-tenant"
          element={<ProtectedRoute element={<TenantSelectPage />} />}
        />

        <Route path="/:slug/invite" element={<InvitePage />} />

        {/* ✅ PRIVATE ROUTES - Wrapped in PrivateLayout */}
        <Route element={<ProtectedRoute element={<PrivateLayout />} />}>
          <Route path=":slug/testing" element={<TestingPage />} />
          <Route path=":slug/appointments" element={<CalendarMain />} />

          <Route path=":slug/profile" element={<UserProfilePage />} />
          <Route path=":slug/onboarding" element={<OnboardingPage />} />

          <Route path=":slug/dashboard" element={<Dashboard />} />

          {/* patients */}
          <Route path=":slug/patients" element={<PatientListNew />} />
          <Route path=":slug/patients/:id" element={<PatientSingleNew />} />

          {/* employees/users */}
          <Route path=":slug/employees" element={<EmployeeList />} />
          <Route path=":slug/employees/:id" element={<EmployeeSingle />} />

          {/* treatment plans */}
          <Route
            path=":slug/treatment-plans"
            element={<TreatmentPlanListNew />}
          />

          {/* settings */}
          <Route
            path=":slug/settings/clinic-settings"
            element={<ClinicSettings />}
          />
          <Route
            path=":slug/settings/clinic-settings/active-modules"
            element={<ActiveModules />}
          />
          <Route
            path=":slug/settings/clinic-settings/payments-and-invoices"
            element={<PaymentsInvoices />}
          />
          <Route
            path=":slug/settings/clinic-settings/users"
            element={<ClinicUsers />}
          />

          <Route path=":slug/settings/services" element={<ServiceListNew />} />
          <Route
            path=":slug/settings/service-groups"
            element={<ServiceGroupListNew />}
          />
          <Route
            path=":slug/settings/professions"
            element={<ProfessionListNew />}
          />
          <Route
            path=":slug/settings/profession-groups"
            element={<ProfessionGroupListNew />}
          />
        </Route>

        {/* ✅ Catch-all for unknown routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
